import { render } from "./CourseDashboard.vue?vue&type=template&id=1a6978f0&ts=true"
import script from "./CourseDashboard.vue?vue&type=script&lang=ts"
export * from "./CourseDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__